var spoiler_default = {
  "fontElementMap": "QuPyW",
  "hideText": "qUnge",
  "onHoverText": "z-Jqy",
  "hideBlock": "yOXK1",
  "smallBlur": "vnbn3",
  "mediumBlur": "fWo1N",
  "largeBlur": "-JGms",
  "hideBlock_gallery": "VQoSX",
  "overlay": "xlpa-",
  "overlay_gallery": "ST6d2",
  "revealSpoilerBtn": "-EBFx",
  "isMobile": "sSgSO",
  "onHoverBtn": "D6hIV",
  "spoilerWrapper": "VBOUj",
  "spoilerDescription": "t-sff",
  "spoilerContainer": "_4CMWm",
  "spoilerContainer_Gallery": "z7FUl",
  "spoiler-text-blur": "_7n-ap"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
